import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-deactivate-og.error-title-non-final',
		defaultMessage: 'Couldn’t turn off Opsgenie contact methods',
		description: 'Error message informing the user that updating turning off failed',
	},
	errorDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-deactivate-og.error-description-non-final',
		defaultMessage:
			'Please try again. If that doesn’t work, you can manually turn off your Opsgenie mobile app in contact methods.',
		description: 'Error message informing the user that updating the field failed',
	},
	errorActionNonFinal: {
		id: 'eoc-changeboarding.services.use-deactivate-og.error-action-non-final',
		defaultMessage: 'Manage contact methods',
		description: 'Error message action redirect user to contact methods',
	},
});
